export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const FULL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const ALTERNATIVE_DATE_FORMAT = 'MM/DD/YY';
